import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext, MobileContext } from '../../../Context';
import AutoSizedText from '../_partials/AutoSizedText';
import ClockIcon from '../../../Icons/Clock';
import { IconSize } from '../../../Icons/IconWrap';
import { getReadingTimeMinutes } from '../../Thumb/helpers';
import Timestamp from '../../../Timestamp';
import s from './Journal.scss';
var JournalFullView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var showDate = !isMobile;
    var _b = useDeviationViewContext(), isFullscreen = _b.isFullscreen, isTheater = _b.isTheater;
    var style = isTheater || isFullscreen || isMobile ? { width: width, height: height } : { width: width };
    var minutes = getReadingTimeMinutes(deviation.textContent);
    return (React.createElement("div", { className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen']), style: style },
        React.createElement("div", { className: s['content-wrap'] },
            React.createElement("div", { className: s['title-wrap'] },
                React.createElement(AutoSizedText, { className: s['title'], tooBigClassName: s['better-fit'], maxHeight: 180 }, deviation.title),
                React.createElement("div", { className: s['subtitle'] },
                    showDate && (React.createElement("span", { className: s['published'] },
                        React.createElement(Timestamp, { timestamp: deviation.publishedTime }))),
                    !!minutes && (React.createElement("span", { className: s['read-time'] },
                        React.createElement(ClockIcon, { className: s['clock'], size: IconSize.SMALL, disableDefaultColors: true }),
                        React.createElement("span", null, t('deviationview.journal.stage.read', { count: minutes })))))),
            isFullscreen && (React.createElement(TextualContent, { deviation: deviation, withArtist: false })))));
};
JournalFullView.displayName = 'JournalFullView';
export default JournalFullView;
//# sourceMappingURL=Journal.js.map